import React from "react";
import PropTypes from "prop-types";

const FormTextAreaEntry = ({ label = "", name = "", autocomplete, value = "", saveChanges = f => f }) => {
    let autocompleteAttr;
    if (autocomplete) {
        autocompleteAttr = {autoComplete: autocomplete};
    }
    return (
        <div>
            <label className="formText w3-text-blue w3-animate-opacity">
                <b>{label}</b>
            </label>
            <textarea
                className="textAreaEntry w3-input w3-border w3-round-large"
                name={name}
                value={value}
                {...autocompleteAttr}
                onChange={evt => saveChanges(name, evt.target.value)}
            />
        </div>
    );
}

FormTextAreaEntry.propTypes = {
    label: PropTypes.string,
    placeholder: PropTypes.string,
    name: PropTypes.string,
    saveChanges: PropTypes.func
};

export default FormTextAreaEntry;
